export const isSuperAdmin = () => {
	return localStorage.getItem("role") === "Superadmin";
};

export const canSeeBonus = () => {
	const role = localStorage.getItem("role");
	return role === "Superadmin" || role === "Manager";
};

// Superadmin & Manager may adjust / reopen closed projects.
export const canManageClosedProject = () => {
	const role = localStorage.getItem("role");
	return role === "Superadmin" || role === "Manager";
};

export const isSupervisorAndSuperAdmin = () => {
	return (
		localStorage.getItem("role") === "Superadmin" ||
		localStorage.getItem("role") === "Manager" ||
		localStorage.getItem("role") === "Lead Designer"
	);
};
